export namespace LocalStorageConstants {
  export const LOCAL_STORAGE_KEY_RESERVATION_READ_CHAT_COUNTS = 'reservationReadChatCounts';
  export const LOCAL_STORAGE_KEY_IS_DRIVER_APPROVED = 'isDriverApproved';
}
